import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDesign } from 'src/interfaces/design';
import { RequestStatus } from 'src/enums/request-status';
import { getDesignAsync } from './actionDesign';
import { FetchState } from 'src/interfaces/requestState';
import { DesignStatus } from 'src/enums/design-status';

export interface DesignState extends FetchState {
    design: IDesign;
}

const initialState: DesignState = {
    design: undefined,
    requestStatus: RequestStatus.None,
    error: '',
};

const designSlice = createSlice({
    name: 'design',
    initialState,
    reducers: {
        setDesignStatus: (state, action: PayloadAction<DesignStatus>) => {
            return { ...state, design: { ...state.design, status: action.payload } };
        },
    },

    extraReducers: builder => {
        // @ts-ignore
        builder
            .addCase(getDesignAsync.pending, state => {
                state.requestStatus = RequestStatus.Loading;
            })
            .addCase(getDesignAsync.fulfilled, (state, action: PayloadAction<IDesign>) => {
                state.requestStatus = RequestStatus.Completed;
                state.design = action.payload;
            })
            .addCase(getDesignAsync.rejected, (state, action: PayloadAction<string>) => {
                state.requestStatus = RequestStatus.Failed;
                state.error = action.payload;
            });
    },
});

export const { setDesignStatus } = designSlice.actions;
export default designSlice.reducer;
